<template>
  <div class="body-content">
    <div class="propiedades">
      <section class="propiedades-container">
        <div class="propiedades-title">
          <h2><span class="bricsa-square"></span>Mis Propiedades</h2>
        </div>
        <div class="propiedades-content">
          <div
            class="property-container container"
            v-for="project in proyectos"
            :key="project.id"
          >
            <div class="property-title">
              <h3>
                <strong>Mi propiedad:</strong
                >{{ project.productoPrincipal.tipo }}
                {{ project.productoPrincipal.numero }} - {{ project.proyecto }}
              </h3>

              <h3><strong>N° de Negocio:</strong>{{ project.negocio }}</h3>
            </div>
            <div class="property-buttonsGroup">
              <router-link
                :to="{
                  name: 'detalle',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon
                  :icon="['fa', 'list']"
                />Detalles</router-link
              >
              <router-link
                :to="{
                  name: 'estado-compra',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon :icon="['fa', 'home']" />Estado de
                Compra</router-link
              >
              <router-link
                :to="{
                  name: 'avance-obra',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
                Obra</router-link
              >
              <router-link
                :to="{
                  name: 'documentos',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon :icon="['fa', 'file']" />Documentos
                Negocios</router-link
              >
              <router-link
                :to="{
                  name: 'pagos',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon
                  :icon="['fa', 'dollar-sign']"
                />Pagos</router-link
              >
              <router-link
                :to="{
                  name: 'documentos-propiedad',
                  params: { idNegocio: project.idNegocio },
                }"
                ><font-awesome-icon :icon="['fa', 'map']" />Documentos
                Propiedad</router-link
              >
            </div>
          </div>
        </div>
      </section>

      <b-loading
        :is-full-page="isFullPage"
        v-model="isLoading"
        :can-cancel="false"
        ><div class="loadTitle">
          <img :src="images.logo" /> <label>Cargando...</label>
        </div></b-loading
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Ubuntu+Mono:wght@400;700&display=swap");
</style>
<script>
import { mapState } from "vuex";
import moment from "moment";
import { GET_PROJECTS } from "@/core/services/store/proyecto.module";
import { GET_NOVEDADES } from "@/core/services/store/contenido.module";
moment.locale("es");

export default {
  //mixins: [validationMixin],
  name: "index",
  components: {},
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg'
            },
      iconPrev: "chevron-left",
      iconNext: "chevron-right",
      autoPlay: true,
      iconPack: "fa",
      isLoading: true,
      isFullPage: true,
    };
  },
  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 1 * 1);
  },
  mounted() {
    this.getProjects();
    this.getNovedades();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  methods: {
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
      });
    },
    getNovedades() {
      this.$Progress.start();
      this.$store.dispatch(GET_NOVEDADES, null).then(() => {
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      projects: (state) => state.proyecto.projects,
      novedades: (state) => state.contenido.novedades,
    }),
    proyectos: function () {
      if (typeof this.projects.proyectos == "undefined") return [];
      console.log(
        "  +++ " +
          typeof this.projects.proyectos +
          " " +
          this.projects.proyectos
      );
      let elementos = this.projects.proyectos;
      elementos.forEach((item) => {
        item.productoPrincipal = item.productos.find((el) => {
          return el.esPrincipal == true ?? {};
        });
      });
      return elementos;
    },
    destacados: function () {
      if (typeof this.novedades.contenidos == "undefined") return {};
      return this.novedades.contenidos.slice(0, 3);
    },
    patenteErrors() {
      const errors = [];
      if (!this.$v.form.patente) return errors;
      !this.$v.form.patente.required && errors.push("Patente es requerido");
      !this.$v.form.patente.patenteEsValido &&
        errors.push("Patente no es válida");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.propiedades {
  .propiedades-container {
    .propiedades-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
        display: flex;
        align-items: baseline;
        span {
          display: block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          background: var(--bricsa-red);
        }
      }
    }
    .propiedades-content {
      display: grid;
      row-gap: 20px;
      .property-container {
        padding: 3% 5% !important;
        display: grid;
        row-gap: 10px;
        -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        .property-title {
          display: grid;
          row-gap: 5px;
          .property-selectButton {
            color: #fff;
            background: var(--bricsa-red);
            border: none;
            padding: 0px 10px;
            height: fit-content;
            justify-self: flex-end;
          }
          h3 {
            text-align: left;
          }
          strong {
            color: var(--bricsa-red);
            margin-right: 5px;
          }
        }
        .property-buttonsGroup {
          display: grid;
          grid-template-columns: repeat(6, calc(90% / 6));
          grid-template-rows: repeat(2, max-content);
          justify-content: space-between;
          row-gap: 10px;
          @media screen and(max-width:1025px) {
            grid-template-columns: repeat(3, 32%);
          }
          @media screen and(max-width:426px) {
            grid-template-columns: 35% 28% 35%;
          }
          a:hover > svg {
            color: #fff;
          }
          a {
            padding: 10px 15px;
            text-align: center;
            color: #7e7e7e;
            align-items: center;
            display: grid;
            grid-template-columns: 100%;
            justify-content: center;
            -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
            -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
            transition: 400ms;
            &:hover {
              background-color: #00457b;
              color: #fff;
            }
            @media screen and(max-width:1024px) {
              display: block;
              font-size: 12px;
            }
            @media screen and(max-width:426px) {
              padding: 5px;
              text-align: left;
              box-shadow: none;
            }
            svg {
              width: 100%;
              height: 30px;
              justify-self: center;
              color: #00457b;
              transition: 400ms;
              &:hover {
                color: #fff;
              }
              @media screen and(max-width:1024px) {
                margin-right: 5px;
              }
              @media screen and(max-width:426px) {
                width: 1em;
                height: 1em;
              }
            }
          }
        }
      }
    }
  }
}
</style>

